import { Component, Input, OnInit, inject } from '@angular/core';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { TIPPY_REF } from '@ngneat/helipopper';

@Component({
  selector: 'app-stage-tooltip',
  templateUrl: './stage-tooltip.component.html',
  styleUrls: ['./stage-tooltip.component.scss'],
})
export class StageTooltipComponent implements OnInit {
  @Input() account: Account;

  sources: string[] = [];
  tippy = inject(TIPPY_REF);

  constructor() {}

  ngOnInit() {}
}
